<template>
    <FKBreadCrumb :page="$t('page.create')" :title="page_title">
    <FKBreadCrumbItem :page="$t('page.system_users')" to="/system-users" />
  </FKBreadCrumb>
    <UserForm />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
  import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
  import UserForm from "@/components/FK/UserForm/UserForm.vue";
  
  export default defineComponent({
    name: "CreateUserPage",
    components: {
      FKBreadCrumb,
      FKBreadCrumbItem,
      UserForm,
    },
    computed: {
      page_title(): string { return this.$route.query.role_name === undefined ? this.$t('page.create_user') : `${this.$t('cta.create')} ${this.$route.query.role_name}`}
    }
  });
  </script>